"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _MuiComponentsContext = _interopRequireDefault(require("./MuiComponentsContext"));

var _GoogleMapApiInitializator = _interopRequireDefault(require("./_GoogleMapApiInitializator"));

function MuiComponentsProvider(_ref) {
  var children = _ref.children,
      googleApiKey = _ref.googleApiKey,
      _ref$linkComponent = _ref.linkComponent,
      linkComponent = _ref$linkComponent === void 0 ? 'a' : _ref$linkComponent;

  var _useState = (0, _react.useState)({
    fabVisible: false,
    googleApiKey: googleApiKey,
    linkComponent: linkComponent
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var handleChangeSettings = _react.default.useCallback(function () {
    var partial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    setState(function (ps) {
      return (0, _extends2.default)({}, ps, partial);
    });
  }, []);

  var setFabVisible = _react.default.useCallback(function (v) {
    return handleChangeSettings({
      fabVisible: v
    });
  }, [handleChangeSettings]);

  return /*#__PURE__*/_react.default.createElement(_MuiComponentsContext.default.Provider, {
    value: (0, _extends2.default)({}, state, {
      updateSettings: handleChangeSettings,
      setFabVisible: setFabVisible
    })
  }, /*#__PURE__*/_react.default.createElement(_GoogleMapApiInitializator.default, {
    googleApiKey: googleApiKey
  }, children));
}

process.env.NODE_ENV !== "production" ? MuiComponentsProvider.propTypes = {
  children: _propTypes.default.node,
  googleApiKey: _propTypes.default.string,
  linkComponent: _propTypes.default.node
} : void 0;
MuiComponentsProvider.displayName = 'MuiComponentsProvider';
var _default = MuiComponentsProvider;
exports.default = _default;